import { Component, model, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { UntypedFormBuilder } from '@angular/forms';
import { ActivatedRoute, NavigationExtras, Router, RouterLink } from '@angular/router';

import { PoolRepository } from '../../lib/pool/repository';
import { PoolComponent } from '../../shared/poolmodule/component';
import { NameService, PersonMap, TeamMap, FootballLine } from 'ngx-sport';
import { PlayerRepository } from '../../lib/ngx-sport/player/repository';
import { NgbAlertModule, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ScoutedPlayerRepository } from '../../lib/scoutedPlayer/repository';
import { Pool } from '../../lib/pool';
import { PoolUserRepository } from '../../lib/pool/user/repository';
import { PoolUser } from '../../lib/pool/user';
import { FormationRepository } from '../../lib/formation/repository';
import { S11Player } from '../../lib/player';
import { S11FormationPlace } from '../../lib/formation/place';
import { GlobalEventsManager } from '../../shared/commonmodule/eventmanager';
import { S11Formation } from '../../lib/formation';
import { StatisticsGetter } from '../../lib/statistics/getter';
import { NavBarItem } from '../../shared/poolmodule/poolNavBar/items';
import { PoolNavBarComponent } from '../../shared/poolmodule/poolNavBar/poolNavBar.component';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { FormationLineAssembleComponent } from './line/assemble.component';
import { faUserSecret, faUsers, faSpinner } from '@fortawesome/free-solid-svg-icons';

@Component({
  selector: "app-pool-assemble",
  standalone: true,
  imports: [
    PoolNavBarComponent,
    NgbAlertModule,
    FontAwesomeModule,
    FormationLineAssembleComponent,
    RouterLink,
  ],
  templateUrl: "./assemble.component.html",
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrls: ["./assemble.component.scss"],
})
export class FormationAssembleComponent
  extends PoolComponent
  implements OnInit
{
  public assembleFormation = model<S11Formation | undefined>();
  nameService = new NameService();
  teamPersonMap = new PersonMap();
  selectedPlace: S11FormationPlace | undefined;
  selectedSearchLine: FootballLine | undefined;
  selectedTeamMap: TeamMap = new TeamMap();
  public statisticsGetter = new StatisticsGetter();
  public faUserSecret = faUserSecret;
  public faUsers = faUsers;
  public faSpinner = faSpinner;

  constructor(
    route: ActivatedRoute,
    router: Router,
    poolRepository: PoolRepository,
    globalEventsManager: GlobalEventsManager,
    protected playerRepository: PlayerRepository,
    protected scoutedPlayerRepository: ScoutedPlayerRepository,
    protected poolUserRepository: PoolUserRepository,
    protected formationRepository: FormationRepository,
    fb: UntypedFormBuilder,
    private modalService: NgbModal
  ) {
    super(route, router, poolRepository, globalEventsManager);
  }

  ngOnInit() {
    super.parentNgOnInit().subscribe({
      next: (pool: Pool) => {
        this.setPool(pool);
        if (pool.getCompetitionConfig().afterAssemblePeriod()) {
          this.router.navigate(["/pool/competition", pool.getId()]);
          return;
        }
        this.poolUserRepository.getObjectFromSession(pool).subscribe({
          next: (poolUser: PoolUser) => {
            this.poolUserFromSession = poolUser;
            this.formationRepository
              .getObject(poolUser, pool.getAssembleViewPeriod())
              .subscribe({
                next: (formation: S11Formation) =>
                  this.assembleFormation.set(formation),
                error: (e: string) => {
                  this.setAlert("danger", e);
                  this.processing.set(false);
                  this.router.navigate([
                    "/pool/formation/choose",
                    pool.getId(),
                  ]);
                },
                complete: () => this.processing.set(false),
              });
          },
          error: (e: string) => {
            this.setAlert("danger", e);
            this.processing.set(false);
          },
          complete: () => this.processing.set(false),
        });
      },
      error: (e) => {
        this.setAlert("danger", e);
        this.processing.set(false);
      },
    });
  }

  get GoalKeeper(): FootballLine {
    return FootballLine.GoalKeeper;
  }
  
  get MyTeam(): NavBarItem {
    return NavBarItem.MyTeam;
  }

  editPlace(pool: Pool, place: S11FormationPlace) {
    const navigationExtras: NavigationExtras = {
      queryParams: {
        line: place.getFormationLine().getNumber(),
        teamId: this.getTeamId(place),
      },
    };
    this.router.navigate(
      ["/pool/formation/place/edit/", pool.getId(), place.getId()],
      navigationExtras
    );
  }

  getTeamId(place: S11FormationPlace): number | undefined {
    return place.getPlayer()?.getLine() ?? undefined;
  }

  linkToPlayer(pool: Pool, s11Player: S11Player): void {
    this.router.navigate(
      ["/pool/player/", pool.getId(), s11Player.getId(), 0] /*, {
      state: { s11Player, "pool": this.pool, currentGameRound: undefined }
    }*/
    );
  }
}
